import { Injectable } from '@angular/core';
import { StatusAvis } from '@models/enums';

@Injectable({
  providedIn: 'root'
})
export class DemandeStatusService {
  showReject(status: string): boolean {
    if (!status) return false;
    return !status.includes('REFUSEES') && status !== StatusAvis.VALIDEES_N5 && status !== StatusAvis.ARCHIVEES;
  }

  showValidate(status: string): boolean {
    if (!status) return false;
    return !status.includes('REFUSEES') && status !== StatusAvis.ARCHIVEES;
  }

  isDeleteable(status: string): boolean {
    return status === StatusAvis.A_VALIDER || status === StatusAvis.A_VALIDER_N0;
  }
  isEditable(status: string): boolean {
    return status === StatusAvis.A_VALIDER || status === StatusAvis.A_VALIDER_N0;
  }

  getStatusText(status: string | undefined): string {
    switch (status) {
      case StatusAvis.A_VALIDER_N0:
        return 'Avis non renseigné - Responsable';
      case StatusAvis.VALIDEES_N0:
        return 'Avis favorable - Responsable';
      case StatusAvis.REFUSEES_N0:
        return 'Avis défavorable - Responsable';
      case StatusAvis.A_VALIDER:
        return 'Avis non renseigné';
      case StatusAvis.VALIDEES_N1:
        return 'Avis favorable - Directeur';
      case StatusAvis.VALIDEES_N2:
        return 'Avis favorable - GS/RH/GPEEC';
      case StatusAvis.VALIDEES_N3:
        return 'Avis favorable - DRH';
      case StatusAvis.VALIDEES_N4:
        return 'Avis favorable - DG';
      case StatusAvis.VALIDEES_N5:
        return 'Avis favorable - DGS';
      case StatusAvis.ARCHIVEES:
        return 'Avis archivé - Gestionnaire RH';
      case StatusAvis.REFUSEES_N1:
        return 'Avis défavorable - Directeur';
      case StatusAvis.REFUSEES_N2:
        return 'Avis défavorable - GS/RH/GPEEC';
      case StatusAvis.REFUSEES_N3:
        return 'Avis défavorable - DRH';
      case StatusAvis.REFUSEES_N4:
        return 'Avis défavorable - DG';
      case StatusAvis.REFUSEES_N5:
        return 'Avis défavorable - DGS';
      case 'ANNULEES':
        return 'Avis non archivé - Gestionnaire RH';
      case 'DEMANDE_AVIS':
        return 'Avis demandé';
      case 'AVIS':
        return 'Avis donné';
      default:
        return status ?? '';
    }
  }

  getStatusClass(status: string | undefined): string {
    switch (status) {
      case StatusAvis.A_VALIDER_N0:
        return 'status-pending';
      case StatusAvis.A_VALIDER:
        return 'status-pending';
      case StatusAvis.VALIDEES_N0:
        return 'status-validated-n1';
      case StatusAvis.VALIDEES_N1:
        return 'status-validated-n1';
      case StatusAvis.VALIDEES_N2:
        return 'status-validated-n2';
      case StatusAvis.VALIDEES_N3:
        return 'status-validated-n3';
      case StatusAvis.VALIDEES_N4:
        return 'status-validated-n4';
      case StatusAvis.VALIDEES_N5:
        return 'status-validated-n5';
      case StatusAvis.REFUSEES_N0:
        return 'status-refused-n1';
      case StatusAvis.REFUSEES_N1:
        return 'status-refused-n1';
      case StatusAvis.REFUSEES_N2:
        return 'status-refused-n2';
      case StatusAvis.REFUSEES_N3:
        return 'status-refused-n3';
      case StatusAvis.REFUSEES_N4:
        return 'status-refused-n4';
      case StatusAvis.REFUSEES_N5:
        return 'status-refused-n4';
      case StatusAvis.ARCHIVEES:
        return 'status-archived';
      case 'ANNULEES':
        return 'status-refused-archived';
      case 'DEMANDE_AVIS':
        return 'demande_avis';
      case 'AVIS':
        return 'avis';
      default:
        return '';
    }
  }
}
